import common from './common.en'
import compound from './compound.en'
import molecularBiomarkers from './molecularBiomarkers.en'
import targets from './targets.en'
import pages from './pages.en'
import evidence from './evidence.en'
import filter from './filter.en'
import report from './report.en'
import validateError from './validateError.en'

const translations = {
    common,
    compound,
    molecularBiomarkers,
    targets,
    pages,
    evidence,
    filter,
    report,
    validateError
}

export default translations
